$(function () {
    function bindEvents() {
        $('#userLogout').on('click', deleteNotifsCookie);
    }
    function deleteNotifsCookie() {
        document.cookie = "ac4_notifs=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
    bindEvents();
});